// extracted by mini-css-extract-plugin
export default {"text":"Title_text__HE1RQ","wiggle":"Title_wiggle__9cK6N"};